interface IData {
    currentDictationFilePaths?: string[],
    nextDictationFilePaths?: string[],
    currentTranscripts?: unknown[],
    nextTranscripts?: unknown[],
}

/**
 * Serializes refresh inputs so same-length arrays with different contents still
 * invalidate stale annotation dictation state in the reader.
 */
function getComparableAnnotationAssetSignature(value: unknown): string {
    if (value === undefined) {
        return 'undefined';
    }

    try {
        return JSON.stringify(value);
    } catch (error) {
        return 'unserializable';
    }
}

/**
 * Checks whether the reader can keep its current annotation dictation assets.
 */
function areAnnotationDictationAssetsEqual({
    currentDictationFilePaths,
    nextDictationFilePaths,
    currentTranscripts,
    nextTranscripts,
}: IData): boolean {
    return (
        getComparableAnnotationAssetSignature(currentDictationFilePaths)
        === getComparableAnnotationAssetSignature(nextDictationFilePaths)
        && getComparableAnnotationAssetSignature(currentTranscripts)
        === getComparableAnnotationAssetSignature(nextTranscripts)
    );
}

export default areAnnotationDictationAssetsEqual;
